import { TabContext, TabList } from "@mui/lab";
import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { StyledTab, StyledTabs } from "./style";
import FAQAccardion from "./FAQAccardion";

const FAQ = ({ id, FAQData }) => {
  const [activeTab, setActiveTab] = useState(FAQData?.faqList?.edges[0]?.node?.id);
  useEffect(() => {
    if (FAQData) setActiveTab(FAQData?.faqList?.edges[0]?.node?.id);
  }, [FAQData]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const filteredArray = FAQData?.faqList?.edges?.filter(
    (item, index) => index === FAQData?.faqList?.edges?.findIndex((o) => item.node.title === o.node.title)
  );

  const selectedTab = FAQData?.faqList?.edges?.filter((item) => item?.node?.id === activeTab);

  if (FAQData) {
    return (
      <Stack spacing={6} textAlign="center" justifyContent="center" py={6} px={2}>
        <TabContext value={activeTab}>
          <Stack spacing={2} direction={{ xs: "column", md: "row" }} justifyContent="space-between">
            {/* desktop device */}
            
            <Stack spacing={2} mb={2} sx={{ display: { xs: "none", md: "flex" } }}>
              <TabList
                value={activeTab}
                onChange={handleChange}
                orientation="vertical"
                TabIndicatorProps={{
                  sx: {
                    width: 0,
                  },
                }}
              >
                {FAQData?.faqList?.edges?.map((item) => (
                  <StyledTab
                    key={item?.node?.id}
                    label={<Typography variant="subtitle1">{item?.node?.title}</Typography>}
                    value={item?.node?.id}
                  />
                ))}
              </TabList>
            </Stack>

            {/* mobile device */}
            <Stack
              direction="row"
              justifyContent="center"
              width="100%"
              alignItems="center"
              bgcolor="grey.gb"
              sx={{ borderRadius: 1.5, display: { md: "none" } }}
            >
              <StyledTabs
                value={activeTab}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                {filteredArray?.map((item) => (
                  <StyledTab
                    key={item.node.id}
                    label={<Typography variant="subtitle1">{item.node.title}</Typography>}
                    value={item.node.id}
                  />
                ))}
              </StyledTabs>
            </Stack>

            <Stack width="100%">
              {selectedTab[0]?.node?.questions?.edges?.map((item) => (
                <FAQAccardion
                  key={item.node.id}
                  index={item.node.id}
                  question={item.node.description}
                  answer={item.node.answers}
                  panel={item.node.id}
                />
              ))}
            </Stack>
          </Stack>
        </TabContext>
      </Stack>
    );
  }
};
export default FAQ;
